import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    item: {
      display: 'block',
      boxShadow: theme.shadows.sm,
      padding: 4,
      height: '100%',
      borderRadius: '4px',
      border: `1px solid ${theme.colors.neutral[0]}`,
      [theme.fn.smallerThan('sm')]: { minHeight: 148 },
      [theme.fn.largerThan('sm')]: {
        padding: '20px 5px',
      },
    },
    inner: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      alignItems: 'center',
      [theme.fn.largerThan('sm')]: {
        gap: 12,
      },
    },
    thumb: {
      [theme.fn.smallerThan('sm')]: {
        width: '100%',
        textAlign: 'center',
        backgroundColor: theme.colors.neutral[0],
        padding: '8px 0',
      },
    },
    thumbImg: {
      height: 64,
      [theme.fn.largerThan('sm')]: {
        height: 80,
      },
    },
    itemHeading: {
      textAlign: 'center',
    },
  }
})
